export default "__VITE_ASSET__Ng01BTF$__"